import { Box, Flex } from '@dapperlabs/core-fe';
import React from 'react';
import { packOddsReduceSum } from 'src/lib/contentful/utils';

import { DistributionExtended } from '../types';
import { PackDropItem } from './PackDropItem';

interface Props {
  distribution: DistributionExtended;
  isActiveDrop?: boolean;
}

export const PackInSingleDrop: React.FC<Props> = ({
  distribution: drop,
  isActiveDrop,
}) => {
  return (
    <Box as='section' mt={{ base: 0, md: 10 }} mx={{ base: 4, lg: 24 }}>
      <Flex
        justifyContent={['space-between', 'center']}
        direction={['column', 'row']}
        gap={8}
      >
        <PackDropItem
          key={drop?.id}
          availableSupply={drop?.availableSupply}
          cardBg={drop?.images?.[1]?.url}
          cardImg={drop?.images?.[0]?.url}
          distributionId={drop?.id}
          endTime={drop?.endTime}
          guaranteeLabel={drop?.guaranteeLabel}
          isActiveDrop={isActiveDrop}
          packPrice={drop?.price?.value}
          packTitle={drop?.title}
          startTime={drop?.startTime}
          tier={drop?.tier}
          totalPacks={drop?.packOdds?.reduce(packOddsReduceSum, 0)}
        />
      </Flex>
    </Box>
  );
};
